<template>
	<div class="optionsWrapper">
		<div v-if="!!heading" class="heading">
			{{heading}}
		</div>
		<div class="options options--checkboxes" :class="'options--' + align">
			<label :for="option.code" class="option" v-for="option in options" :key="option.label" :style="style" :class="option.inactive ? 'option--inactive' : ''" ><div>{{option.label}}</div>
				<input @click="change(option.code)" :checked="option.checked" :value="option.code" :id="option.code" name="search-option" class="option__checkbox" type="checkbox" :disabled="option.inactive ? true : false">
				<span class="option__checkmark"></span>
			</label>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Checkboxes',
		props: {
			options: {
				type: Array,
				required: true,
			},
			align: {
				type: String,
				default: 'regular',
			},
			width: {
				type: String,
				default: '300'
			},
			heading: {
				type: String,
				default: ''
			}
		},
		methods: {
			change: function(value) {
				this.$emit('change', value)
			}
		},
		computed: {
			style: function() {
				return this.align == 'regular' ? { width: this.width == 'auto' ? '' : this.width + 'px' } : { flexBasis: this.width == 'auto' ? 'auto' : this.width + 'px' }
			}
		}
	}
</script>
<style lang="scss">
	.heading {
		text-transform: uppercase;
		margin-bottom: .7em;
	}
	.options--checkboxes {
		&.options--flex {
			display: flex;
			flex-wrap: wrap;
			gap: .5em .5em;
		}
		.option {
			flex: 0 1 130px;
			font-size: 1em;
			line-height: 1.1;
			display: block;
			position: relative;
			padding: 0 10px 0 30px;
			margin: 0 0em 1em;
			// margin-left: .8em;
			// margin-right: .8em;
			cursor: pointer;
			-webkit-user-select: none;
			-moz-user-select: none;
			-ms-user-select: none;
			user-select: none;
			&--inactive {
				opacity: .3;
			}
			input {
				position: absolute;
				opacity: 0;
				cursor: pointer;
				&:checked {
					~ {
						.option__checkmark {
							background-color: red;
							&:after {
								display: block;
							}
						}
					}
				}
			}
			&__checkmark {
				position: absolute;
				top: 0;
				left: 0;
				height: 20px;
				width: 20px;
				background-color: #eee;
				&::after {
					content: "";
					position: absolute;
					display: none;
					left: 7px;
					top: 4px;
					width: 5px;
					height: 10px;
					border: solid white;
					border-width: 0 3px 3px 0;
					-webkit-transform: rotate(45deg);
					-ms-transform: rotate(45deg);
					transform: rotate(45deg);
				}
			}
			&:not(.option--inactive):hover {
				input {
					~ {
						.option__checkmark {
							background-color: #ccc;
						}
					}
				}
			}
		}
	}

</style>